import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isArray } from 'lodash';

import deleteStudio from 'Api/studio/deleteStudio';
import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';
import { useModal } from 'Store/modal';
import { studioDeleteModalText } from 'Const/studio/text';
import { useStudioState } from 'View/studio/state';

const useDeleteStudio = () => {
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();
  const { updateState } = useStudioState();
  const { onResetModal } = useModal();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      onShowLoader({ variant: 'loader-primary' });

      return await deleteStudio({ id });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['studio'] });

      onOpenToast({
        status: 'success',
        description: studioDeleteModalText?.successDescription,
        duration: 5,
        alwaysShow: false,
      });

      onResetModal();
    },
    onError: (error) => {
      console.log(error);
      const errorMessage = isArray(error?.response?.data) ? error?.response?.data?.errors[0]?.message : studioDeleteModalText?.errorDescription;
      onResetModal();
      updateState({
        alertProps: {
          isOpen: true,
          type: 'error',
          title: studioDeleteModalText?.errorTitle,
          description: errorMessage,
          onClose: () => updateState({ alertProps: {} }),
          marginBottom: '12px',
        },
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useDeleteStudio;
